import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b8d6dd0e")

_pushScopeId("data-v-b8d6dd0e")
const _hoisted_1 = { class: "card-body-users" }
const _hoisted_2 = { class: "user-add-btn p-relative" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-plus-circle pr-20" }, null, -1)
const _hoisted_4 = { class: "setting-users-filter" }
const _hoisted_5 = { class: "setting-users-filter-input" }
const _hoisted_6 = { class: "setting-users-filter-btn" }
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-24" }, null, -1)
const _hoisted_8 = { class: "setting-users" }
const _hoisted_9 = { class: "setting-users-header" }
const _hoisted_10 = { class: "setting-header-user-name" }
const _hoisted_11 = { class: "setting-header-user-profile" }
const _hoisted_12 = { class: "setting-header-user-status" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "setting-header-user-empty" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "setting-user-item"
}
const _hoisted_15 = { class: "setting-user-name" }
const _hoisted_16 = { class: "setting-user-profile" }
const _hoisted_17 = { class: "setting-user-edit text-r" }
const _hoisted_18 = { class: "users-showmore" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("button", {
        class: "new-user-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.editUser(0)))
      }, [
        _hoisted_3,
        _createTextVNode(_toDisplayString(_ctx.$t('btn.new-user')), 1)
      ])
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _withDirectives(_createVNode("input", {
          placeholder: _ctx.$t('placeholder.name-username-profile-search'),
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchText = $event))
        }, null, 8, ["placeholder"]), [
          [_vModelText, _ctx.searchText]
        ]),
        (_ctx.searchText.length > 0)
          ? (_openBlock(), _createBlock("i", {
              key: 0,
              class: "icon-f icon-delete-cross fs-10",
              style: {"color":"rgb(173, 172, 183)"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchText = ''), _ctx.getUsersByFilter()))
            }))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("button", {
          type: "button",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getUsersByFilter()))
        }, [
          _hoisted_7
        ])
      ])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('title.username')), 1),
        _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('title.profile')), 1),
        _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('title.status')), 1),
        _hoisted_13
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.showUsers, (user, index) => {
        return (_openBlock(), _createBlock("div", {
          key: user.id
        }, [
          (_ctx.showMore || index < 3)
            ? (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("span", {
                    onClick: ($event: any) => (_ctx.editUser(user.id))
                  }, _toDisplayString(user.userName), 9, ["onClick"])
                ]),
                _createVNode("div", _hoisted_16, _toDisplayString(user.profileName), 1),
                _createVNode("div", {
                  class: ["setting-user-status", 'setting-user-status-' + user.active]
                }, _toDisplayString(user.active ? _ctx.$t('label.active') : _ctx.$t('label.notactive')), 3),
                _createVNode("div", _hoisted_17, [
                  _createVNode("i", {
                    class: "icon-f icon-pencil-edit fs-16",
                    onClick: ($event: any) => (_ctx.editUser(user.id))
                  }, null, 8, ["onClick"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createVNode("div", _hoisted_18, [
        (_ctx.showUsers.length > 3)
          ? (_openBlock(), _createBlock("span", {
              key: 0,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showMore = !_ctx.showMore))
            }, _toDisplayString(_ctx.showMore ? _ctx.$t('btn.show-less') : _ctx.$t('btn.show-more')), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})